import { CYCLE_STEP_COLORS, CYCLE_STEP_LABELS, TASK_STATUS_COLORS, TASK_STATUS_LABELS } from './constants'

export const getTaskStatusMapping = (statusId: string) => ({
	color: TASK_STATUS_COLORS[statusId as keyof typeof TASK_STATUS_COLORS] || '#6B7280',
	label: TASK_STATUS_LABELS[statusId as keyof typeof TASK_STATUS_LABELS] || statusId,
})

export const getCycleStepMapping = (stepId: string) => ({
	color: CYCLE_STEP_COLORS[stepId as keyof typeof CYCLE_STEP_COLORS] || '#6B7280',
	label: CYCLE_STEP_LABELS[stepId as keyof typeof CYCLE_STEP_LABELS] || stepId,
})
